import Dashboard from './pages/dashboard/dashboard'
import Fleet from './pages/fleet'
import Reports from './pages/reports/reports'
import { LogoutLandingPage } from './pages/logout-callback/logoutCallback'

export const getRoutes = (geoLocationNotAllowed) => {
  const routes = []

  if (geoLocationNotAllowed) {
    routes.push(
      {
        url: '/login_success',
        name: 'Applications',
        component: Reports,
        icon: 'MdDashboard',
      },
      {
        url: '/',
        name: 'Applications',
        tooltip: 'Applications overview and reports',
        component: Reports,
      }
    )
  } else {
    routes.push(
      {
        url: '/login_success',
        name: 'Callback',
        component: Dashboard,
        icon: 'MdDashboard',
      },
      {
        url: '/',
        name: 'header.map',
        tooltip: 'Fleet overview',
        component: Dashboard,
        icon: 'MapIcon',
        navbar: true,
      }
    )
  }

  routes.push(
    {
      url: '/logout/*',
      name: 'Logout',
      public: true, 
      component: LogoutLandingPage,
    },
    {
      url: '/reports/dashboard',
      name: 'header.applications',
      tooltip: 'Applications overview and reports',
      component: Reports,
      icon: 'ApplicationsIcon',
      navbar: true,
    },
    {
      url: '/reports/:option?/:summaryId?/:detailsId?',
      name: 'Reports',
      component: Reports,
    },
    {
      url: '/fleet',
      name: 'header.myFleet',
      tooltip: 'Vehicles and users overview',
      component: Fleet,
      icon: 'FleetIcon',
      navbar: true,
    },
    {
      url: '/fleet/:option?/:domainId?/',
      name: 'Fleet option',
      component: Fleet,
    }
  )
  return routes
}
